import type { Difficulty } from '@/domain/episode'

const STYLES: Record<Difficulty, string> = {
  beginner: 'bg-teal-500/15 text-teal-300 ring-1 ring-teal-500/30',
  intermediate: 'bg-amber-500/15 text-amber-300 ring-1 ring-amber-500/30',
  advanced: 'bg-coral-500/15 text-coral-500 ring-1 ring-coral-500/30',
}

const LABELS: Record<Difficulty, string> = {
  beginner: 'Beginner',
  intermediate: 'Intermediate',
  advanced: 'Advanced',
}

export function DifficultyBadge({ difficulty }: { difficulty: Difficulty }) {
  return <span className={`cyber-pill ${STYLES[difficulty]}`}>{LABELS[difficulty]}</span>
}
